import classNames from "classnames"
import React from "react"
import { SanityImg } from "../../../cms/components"
import { TwRichTextField } from "../../../root/punks/core/fields/RichTextField"
import ExpandableText from "../../../ui/atoms/ExpandableText"
import Typography from "../../../ui/atoms/Typography"
import classes from "./BrandPageHead.module.css"

interface Props {
  contents: any
}

const BrandPageHead = ({ contents }: Props) => {
  const size = contents.ref.brand?.data?.logoSize
  return (
    <div className="text-center">
      {contents.ref.brand?.data?.logo?.asset ? (
        <SanityImg
          asset={contents.ref.brand?.data?.logo?.asset}
          className={classNames(classes.brandLogo, {
            [classes.brandLogoSmall]: !size || size === "small",
            [classes.brandLogoMedium]: size === "medium",
            [classes.brandLogoLarge]: size === "large",
            [classes.brandLogoXl]: size === "xl",
          })}
        />
      ) : (
        <Typography variant="h4" textClassName="my-4">
          {contents.data.info.title}
        </Typography>
      )}
      {contents.ref?.brand?.data?.description && (
        <div className={classes.description}>
          <ExpandableText
            disabled={!contents.ref?.brand?.data?.descriptionExpandable}
          >
            <TwRichTextField
              variant="subtitle2"
              component="p"
              value={contents.ref?.brand?.data?.description}
              fillLine
            />
          </ExpandableText>
        </div>
      )}
    </div>
  )
}

export default BrandPageHead
